export default __webpack_public_path__ + "static/media/slide7.74b72923.jpg";